import React, { useState } from 'react';

const Brochure = () => {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ name: '', email: '', phone: '' });

  const downloadBrochure = () => {
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Fetch dynamic data from backend
    try {
      const [servicesRes, productsRes] = await Promise.all([
        fetch(`${process.env.REACT_APP_API_URL}/api/services/`),
        fetch(`${process.env.REACT_APP_API_URL}/api/products/`)
      ]);
      const services = await servicesRes.json();
      const products = await productsRes.json();
      
      // Generate brochure with dynamic data
      generateBrochure(services, products);
    } catch (error) {
      console.error('Error fetching data:', error);
      // Generate with fallback data
      generateBrochure([], []);
    }
  };

  const generateBrochure = (services, products) => {
    
    // Send user details to email
    const formElement = document.createElement('form');
    formElement.action = 'https://formsubmit.co/contact@enessafoods.com';
    formElement.method = 'POST';
    formElement.style.display = 'none';
    
    const fields = [
      { name: '_subject', value: 'Brochure Download Request - Enessa Foods' },
      { name: 'Name', value: formData.name },
      { name: 'Email', value: formData.email },
      { name: 'Phone', value: formData.phone },
      { name: '_captcha', value: 'false' },
      { name: '_template', value: 'table' }
    ];
    
    fields.forEach(field => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = field.name;
      input.value = field.value;
      formElement.appendChild(input);
    });
    
    document.body.appendChild(formElement);
    formElement.submit();
    
    // Download brochure
    const brochureContent = `
<!DOCTYPE html>
<html>
<head>
    <meta charset="UTF-8">
    <title>ENESSA FOODS - Company Brochure</title>
    <style>
        body { font-family: Arial, sans-serif; margin: 0; padding: 20px; background: #f8f9fa; }
        .brochure { max-width: 800px; margin: 0 auto; background: white; border-radius: 15px; overflow: hidden; box-shadow: 0 10px 30px rgba(0,0,0,0.1); }
        .header { background: linear-gradient(135deg, #e74c3c, #c0392b); color: white; padding: 40px; text-align: center; }
        .logo { font-size: 48px; font-weight: bold; margin-bottom: 10px; }
        .tagline { font-size: 18px; opacity: 0.9; }
        .section { padding: 30px; }
        .section h2 { color: #2c3e50; border-bottom: 3px solid #e74c3c; padding-bottom: 10px; margin-bottom: 20px; }
        .stats { display: flex; justify-content: space-around; background: #f8f9fa; padding: 20px; margin: 20px 0; border-radius: 10px; }
        .stat { text-align: center; }
        .stat-number { font-size: 32px; font-weight: bold; color: #e74c3c; }
        .services { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin: 20px 0; }
        .service { background: #f8f9fa; padding: 20px; border-radius: 10px; border-left: 4px solid #e74c3c; }
        .contact { background: #2c3e50; color: white; padding: 30px; text-align: center; }
        .contact h2 { color: white; border-bottom-color: #e74c3c; }
    </style>
</head>
<body>
    <div class="brochure">
        <div class="header">
            <div class="logo">ENESSA FOODS</div>
            <div class="tagline">Premium Bakery Raw Materials & Solutions</div>
        </div>
        
        <div class="section">
            <h2>About Us</h2>
            <p>Enessa Foods is a leading provider of premium bakery ingredients and solutions in India. With decades of experience and deep industry knowledge, we partner with bakeries of all sizes—from artisan operations to large-scale production facilities—to deliver innovative, high-quality ingredients that elevate baking standards.</p>
            <p>Our commitment to excellence, sustainability, and customer success has made us a trusted name in the Indian baking industry. We combine global expertise with local insights to provide tailored solutions that meet the unique challenges of Indian bakeries.</p>
        </div>
        
        <div class="section">
            <h2>Our Services</h2>
            <div class="services">
                ${services.map(service => `
                <div class="service">
                    <h3>${service.title}</h3>
                    <p>${service.description || 'Comprehensive solutions tailored to your needs.'}</p>
                </div>
                `).join('')}
            </div>
        </div>
        
        <div class="section">
            <h2>Our Products</h2>
            <ul style="columns: 2; column-gap: 30px;">
                ${products.map(product => `<li>${product.title}</li>`).join('')}
            </ul>
        </div>
        
        <div class="section">
            <h2>Innovation & Technology</h2>
            <ul>
                <li><strong>R&D Solutions:</strong> Custom formulation development and process optimization</li>
                <li><strong>New Technologies:</strong> Cutting-edge bakery technologies including encapsulated acids and clean-label solutions</li>
                <li><strong>Product Development:</strong> From concept to market-ready products with comprehensive support</li>
                <li><strong>Industry Research:</strong> Market insights and trend analysis for strategic decisions</li>
            </ul>
        </div>
        
        <div class="section">
            <h2>Why Choose Enessa Foods?</h2>
            <ul>
                <li><strong>Global Expertise:</strong> Deep industry knowledge with international standards</li>
                <li><strong>Trusted Partner:</strong> Established name in the Indian baking industry</li>
                <li><strong>Scalable Solutions:</strong> Serving artisan bakeries to large-scale operations</li>
                <li><strong>Innovation Focus:</strong> Cutting-edge R&D and sustainable practices</li>
                <li><strong>Quality Assurance:</strong> Rigorous quality control and consistency standards</li>
                <li><strong>Cost Effective:</strong> Competitive pricing without compromising quality</li>
            </ul>
        </div>
        
        <div class="contact">
            <h2>Contact Us</h2>
            <p><strong>Address:</strong><br>
            Office No. 204, M.M. Palace,<br>
            Kondhwa Khurd, Pune, Maharashtra, India<br>
            PIN Code: 411048</p>
            
            <p><strong>Phone:</strong> +91 9823107666 / +91 9823108666</p>
            <p><strong>Email:</strong> contact@enessafoods.com</p>
            
            <p style="margin-top: 30px; font-size: 18px;">
                <strong>Ready to elevate your baking?</strong><br>
                Contact us today for customized solutions!
            </p>
        </div>
    </div>
</body>
</html>`;

    const blob = new Blob([brochureContent], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'Enessa-Foods-Brochure.html';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    
    setShowModal(false);
    setFormData({ name: '', email: '', phone: '' });
  };

  const BrochureModal = () => (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={() => setShowModal(false)}>
      <div className="bg-white rounded-3xl p-8 max-w-md w-full" onClick={(e) => e.stopPropagation()}>
        <h3 className="text-2xl font-bold text-[#3b1b0d] mb-4">Download Brochure</h3>
        <p className="text-[#7b5b3a] mb-6">Please provide your details to download our brochure</p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-[#3b1b0d] font-medium mb-2">Name *</label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              className="w-full px-4 py-3 rounded-xl border-2 border-[#f2e1c5] focus:border-[#b42b2b] focus:outline-none"
              required
            />
          </div>
          <div>
            <label className="block text-[#3b1b0d] font-medium mb-2">Email *</label>
            <input
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
              className="w-full px-4 py-3 rounded-xl border-2 border-[#f2e1c5] focus:border-[#b42b2b] focus:outline-none"
              required
            />
          </div>
          <div>
            <label className="block text-[#3b1b0d] font-medium mb-2">Phone *</label>
            <input
              type="tel"
              value={formData.phone}
              onChange={(e) => setFormData({...formData, phone: e.target.value})}
              className="w-full px-4 py-3 rounded-xl border-2 border-[#f2e1c5] focus:border-[#b42b2b] focus:outline-none"
              required
            />
          </div>
          <div className="flex gap-3 pt-4">
            <button
              type="submit"
              className="flex-1 bg-[#b42b2b] text-white px-6 py-3 rounded-full font-medium hover:bg-[#8f2222] transition-colors"
            >
              Download
            </button>
            <button
              type="button"
              onClick={() => setShowModal(false)}
              className="flex-1 bg-gray-200 text-gray-700 px-6 py-3 rounded-full font-medium hover:bg-gray-300 transition-colors"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );

  return { downloadBrochure, BrochureModal: showModal ? BrochureModal : null };
};

export default Brochure;
